import React, { useEffect, useState } from 'react';
import { RecepcionesNH3Api } from '../../../../../Utils/APIs/bonificacionesApi/RecepcionesNH3Api';
import TotalesBonificacion from '../../../../../Utils/Components/TotalesBonificacion';
import TablaBonifNH3 from '../../../../../Utils/Components/RecepcionesBonificacion/TablaBonifNH3';
import '../RecepcionesBonificacion.css';

/**
 * Componente que muestra las recepciones de NH3 y sus bonificaciones.
 * @param {Object} props - Props del componente.
 * @param {number} props.orden_compra_id - ID de la orden de compra.
 * @param {function} props.setTotalesNH3 - Función para establecer los totales de NH3.
 * @returns {JSX.Element} - Componente de recepciones de NH3.
 */
const RecepcionesNH3 = (props) => {
    const { orden_compra_id, setTotalesNH3, setRecepcionesNH3 } = props;
    const { getRecepcionesNH3, getTotalesNH3 } = RecepcionesNH3Api();
    const [recepciones, setRecepciones] = useState([]);

    // TOTALES
    const [totalesBonificacion, setTotalesBonificacion] = useState({
        total_bonificaciones: 0,
        total_kg: 0,
        total_bonos: 0,
        total_bonos_quetzales: 0,
    });

    const getData = async () => {
        const recepcionesNH3 = await getRecepcionesNH3({ orden_compra_id });
        const totales = await getTotalesNH3({ orden_compra_id });
        setRecepciones(recepcionesNH3.results || []);
        if (setRecepcionesNH3) setRecepcionesNH3(recepcionesNH3.results || []);
        setTotalesBonificacion(totales || {});
        if (setTotalesNH3) setTotalesNH3(totales);
    }

    useEffect(() => {
        if (!!orden_compra_id) {
            getData();
        }
    }, [orden_compra_id]);

    return (
        <div className='row'>
            <div className='col-12'>
                <div className='mx-3 my-2 mb-4'>
                    <div className="recepciones-bonificacion-ver">
                        {/* Solo mostrar si hay recepciones */}
                        {recepciones && recepciones.length > 0 && (
                            <div>
                                <h4 className='mb-2 text-center'>Bonificación NH3</h4>
                                {/* TABLA */}
                                <div className='new-table-wrapper liquidaciones-crear__table-wrapper'>
                                    <TablaBonifNH3 recepciones={recepciones} />
                                </div>
                                {/* TOTALES */}
                                <TotalesBonificacion
                                    totalesBonificacion={totalesBonificacion}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>

    )
};

export default RecepcionesNH3;
